import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { DocTextIcon16Solid } from "../../../../../icons2022/FileTypeDocTextIcon/DocTextIcon16Solid";
import { DocTextIcon20Solid } from "../../../../../icons2022/FileTypeDocTextIcon/DocTextIcon20Solid";
import { DocTextIcon24Solid } from "../../../../../icons2022/FileTypeDocTextIcon/DocTextIcon24Solid";
export var DocTextIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(DocTextIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(DocTextIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(DocTextIcon24Solid, null);
  }
}, 'DocTextIcon');